import React, { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import SideMenuInernal from "../../components/SideMenuInernal";
import { notificationNavMenu } from "../../constants/NavMenus";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Pagination from "@mui/material/Pagination";
import { ReactComponent as CogIcon } from "../../assets/Icons/cog.svg";
import { ReactComponent as CorrectIcon } from "../../assets/Icons/correct.svg";
import Menu from "@mui/material/Menu";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Button from "@mui/material/Button";
import {
  updateNotificationReadStatus,
  getNotificationList,
  updateSingleNotificationReadStatus,
} from "../../services/home.services";

import { useNavigate } from "react-router-dom";
import paths from "../../constants/paths";
import { useAlert } from "../../contexts/Alert";
import MainLayout from "../../layouts/MainLayout";
import { useNotifcations } from "../../contexts/Notifications";
import Tooltip from "@mui/material/Tooltip";
import { formatTimestamp } from "../../utils/formatTimestamp";
import { trackClickEvent } from "../../mixpanel";

const Notifcations = () => {
  const [currentTab, setCurrentTab] = useState("All");
  const [myPostsFilter, setMyPostsFilter] = useState(false);
  const [postsFromOthersFilter, setPostsFromOthersFilter] = useState(false);
  const [link, setLink] = useState(undefined);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState(null);
  const [notificationsListData, setNotificationsListData] = useState([]);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const { sendAlert } = useAlert();
  const { updateNotificationData, updateNotificationUser } = useNotifcations();

  const getNotificationHandler = () => {
    const data = { page: currentPage };
    if (currentTab !== "All") data["type"] = currentTab;
    if (myPostsFilter) data["my_posts"] = true;
    if (currentTab === "Post" && postsFromOthersFilter)
      data["other_posts"] = true;

    getNotificationList(data)
      .then((res) => {
        setNotificationsListData(res.data.data);
        setPaginationData({
          current_page: res.data.current_page,
          last_page: res.data.last_page,
          total: res.data.total,
          per_page: res.data.per_page,
        });
        updateNotificationData(res.data.data, res.data.unseen_count);
      })
      .catch((error) => {
        sendAlert(error.response?.data?.message, "error");
      });
  };

  useEffect(() => {
    getNotificationHandler();
  }, [currentTab, myPostsFilter, postsFromOthersFilter, currentPage]);

  // Reset filters and pagination when changing tabs
  useEffect(() => {
    setMyPostsFilter(false);
    setPostsFromOthersFilter(false);
    setCurrentPage(1);
  }, [currentTab]);

  // Reset pagination when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [myPostsFilter, postsFromOthersFilter]);

  // Scroll to top when page changes
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [currentPage]);

  useEffect(() => {
    if (link) {
      navigate(link);
    }
  }, [link]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePagination = (_, page) => {
    setCurrentPage(page);
  };

  const handleOnMarkAllClick = () => {
    updateNotificationReadStatus()
      .then((res) => {
        getNotificationHandler();
        sendAlert(res.data.data.message, "success");
        trackClickEvent("Clicked Mark All as Read", {
          component: "Notifications menu",
          page: "Notification",
        });
      })
      .catch((error) => {
        sendAlert(error.response?.data?.message, "error");
      });
  };

  const handleOnNotificationClick = (id, link, user) => {
    updateNotificationUser(user);
    updateSingleNotificationReadStatus(id)
      .then((res) => {
        getNotificationHandler();
        // sendAlert(res.data.data.message, "success");
        trackClickEvent("Clicked Notification", {
          component: "Notifications menu",
          page: "Notification",
          notification_type: currentTab,
        });
        setLink(link);
      })
      .catch((error) => {
        sendAlert(error.response?.data?.message, "error");
        setLink(link);
      });
  };

  const openNavigationSetting = (createdAt) => {
    trackClickEvent("Clicked Notification Settings", {
      component: "Notifications menu",
      page: "Notification",
    });
    navigate(paths.settingsNotifications);
  };

  return (
    <MainLayout currentPage="Notifications">
      <Container>
        <Grid item xs={12} md={12}></Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={2.4}>
            <SideMenuInernal
              menu={notificationNavMenu}
              withBackground
              currentTab={currentTab}
              onClick={(item) => {
                setCurrentTab(item?.type);
                // Reset filters when changing tabs
                setMyPostsFilter(false);
                setPostsFromOthersFilter(false);
                trackClickEvent(
                  `Clicked Notifications Category - ${item?.type}`,
                  {
                    component: "Notifications menu",
                    page: "Notification",
                    tab: item?.type,
                  },
                );
              }}
            />
          </Grid>
          <Grid item xs={12} md={8}>
            <Paper
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                component="form"
                sx={{
                  p: 2,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "#FFFFFF",
                  borderTopLeftRadius: 8,
                  borderTopRightRadius: 8,
                }}
              >
                <Box style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  {![
                    "share-profile",
                    "Referral",
                    "availability-updates",
                  ].includes(currentTab) && (
                    <Chip
                      label="My Posts"
                      color={myPostsFilter ? "primary" : undefined}
                      variant={!myPostsFilter ? "outlined" : undefined}
                      onClick={() => {
                        setMyPostsFilter(!myPostsFilter);
                        trackClickEvent("Clicked My Posts", {
                          component: "Notifications menu",
                          page: "Notification",
                        });
                      }}
                    />
                  )}
                  {currentTab === "Post" && (
                    <Chip
                      label="Posts from others"
                      color={postsFromOthersFilter ? "primary" : undefined}
                      variant={!postsFromOthersFilter ? "outlined" : undefined}
                      onClick={() => {
                        setPostsFromOthersFilter(!postsFromOthersFilter);
                        trackClickEvent("Clicked Posts from others", {
                          component: "Notifications filter",
                          page: "Notification",
                        });
                      }}
                    />
                  )}
                </Box>
                <Box>
                  <Button
                    id="basic-button"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                    sx={{ fontSize: "18px", color: "black" }}
                  >
                    ...
                  </Button>
                </Box>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuList>
                    <MenuItem onClick={handleOnMarkAllClick}>
                      <ListItemIcon>
                        <CorrectIcon />
                      </ListItemIcon>
                      <ListItemText>Mark all as read</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={openNavigationSetting}>
                      <ListItemIcon>
                        <CogIcon />
                      </ListItemIcon>
                      <ListItemText>Notification settings</ListItemText>
                    </MenuItem>
                  </MenuList>
                </Menu>
              </Box>
              <Divider />
              <Box>
                {notificationsListData?.length
                  ? notificationsListData?.map((item, index) => {
                      return (
                        <>
                          <Box
                            className="notification-row"
                            key={index}
                            sx={{
                              display: "flex",
                              width: "100%",
                              flexDirection: "row",
                              justifyContent: "space-around",
                              alignItems: "center",
                              px: 3,
                              py: 1,
                            }}
                            onClick={() => {
                              const userData = {
                                ...item?.user,
                                user_profile_image: item?.user?.main_image,
                              };
                              handleOnNotificationClick(
                                item?.id,
                                item?.link,
                                userData,
                              );
                            }}
                          >
                            <Avatar
                              alt="user Image"
                              src={item?.user?.main_image}
                              align="center"
                              style={avatarStyle}
                            />
                            <Typography
                              variant="body1"
                              sx={{ width: "80%", fontSize: 14 }}
                            >
                              {/* A standalone message is a whole sentence
                                  ("Your referral to X was accepted by Y."),
                                  so it gets no name in front. */}
                              {item?.standalone ? (
                                // The " . " before the time already ends it.
                                item?.message?.replace(/\.$/, "")
                              ) : (
                                <>
                                  <span style={{ fontWeight: "bold" }}>
                                    {item?.user?.first_name}{" "}
                                    {item?.user?.last_name}
                                  </span>
                                  , {item?.message}
                                </>
                              )}
                              <span
                                style={{ color: "#949A9E", fontSize: "14px" }}
                              >
                                {" "}
                                .{" "}
                                <Tooltip
                                  title={
                                    formatTimestamp(item?.created_at)
                                      .tooltipTime
                                  }
                                  placement="top"
                                >
                                  <span>
                                    {
                                      formatTimestamp(item?.created_at)
                                        .displayTime
                                    }
                                  </span>
                                </Tooltip>
                              </span>
                            </Typography>
                            {!item?.seen ? (
                              <div
                                style={{
                                  ...readFlagStyle,
                                  backgroundColor: "#0C8CE9",
                                }}
                              ></div>
                            ) : (
                              <div style={readFlagStyle}></div>
                            )}
                          </Box>
                          <Divider />
                        </>
                      );
                    })
                  : null}
              </Box>
              {paginationData && paginationData.last_page > 1 && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    py: 3,
                  }}
                >
                  <Pagination
                    count={paginationData.last_page}
                    shape="rounded"
                    color="primary"
                    onChange={handlePagination}
                    page={currentPage}
                  />
                </Box>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </MainLayout>
  );
};

const avatarStyle = {
  width: "50px",
  height: "50px",
  borderRadius: "50%",
};

const readFlagStyle = {
  width: "12px",
  height: "12px",
  borderRadius: "50%",
};

export default Notifcations;
